import { request, requestData } from '@/lib/api-client';

/**
 * Web-push registration for this install.
 *
 * `audience: 'PHARMACY'` is not decoration. One person is often shop staff, a
 * customer and sometimes a rider on the same browser, and every app's service
 * worker resolves a notification's `url` against ITS OWN origin — so without
 * it a customer's `/orders/<id>` would open here as a 404, and this app's
 * `/orders` would open on the customer site. The server refuses a subscription
 * that does not say which app it is.
 */
export const pushApi = {
  /** `null` means the server has no VAPID key, so there is nothing to join. */
  publicKey(): Promise<{ publicKey: string | null }> {
    return requestData<{ publicKey: string | null }>('/push/public-key');
  },

  subscribe(input: {
    endpoint: string;
    keys: { p256dh: string; auth: string };
  }): Promise<void> {
    return request<void>('/me/push-subscriptions', {
      method: 'POST',
      body: { ...input, audience: 'PHARMACY' },
    });
  },

  unsubscribe(endpoint: string): Promise<void> {
    return request<void>('/me/push-subscriptions', { method: 'DELETE', body: { endpoint } });
  },
};
